<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

  import {sgettext} from '../../i18n.js';
  import Modal from '../Modal.svelte';
  import {get} from '../../utils.js';

  export let title = sgettext('$$USAGE_BRANCHES$$');
  export let data = {results: []};
  export let globalHazardId;
  export let globalHazardName;
  let loading = false;

  export let modalId = 'branchConfigurations';
  let branchHazardControls = [];

  function getUrl(id){
    return `${PATH_PREFIX}/sw/api/globalhazard/get_branch_configurations/?hazard=${id}`;
  }

  $: if (globalHazardId) {
    getUsageInBranches();
  }

  async function getUsageInBranches() {
    loading = true;
    branchHazardControls = [];

    let url = getUrl(globalHazardId);
    const response = await get(url);
    const json = await response.json();
    try {
      branchHazardControls = [...json];
    } catch (_) {}

    if (branchHazardControls.length > 0) {
      globalHazardName = branchHazardControls[0].global_hazard.name;
    }
    loading = false;
  }

</script>

<style>
  td {
    text-align: left !important;
  }
</style>


<Modal
  id={modalId}
  title={sgettext("$$USAGE_BRANCHES$$")}
  backdrop={'static'}
  extraLarge={true}
>
  <div slot="body">
    {#if loading}
      <i class="fa fa-spinner fa-spin"></i>
    {:else}
      <h4>{sgettext('$$RISK$$')}: {globalHazardName}</h4>
      <p>
        {branchHazardControls.length}
        {#if branchHazardControls.length === 1}
          {sgettext('$$CONFIGURATION$$')}
        {:else}
          {sgettext('$$CONFIGURATIONS$$')}
        {/if}
      </p>

      <div style="overflow: auto; max-height: 500px">
        <table class="table">
          <thead>
            <tr>
              <th style="width: 50%">{sgettext('$$BRANCH$$')}</th>
              <th style="width: 50%">{sgettext('$$CONTROL$$')}</th>
            </tr>
          </thead>
          <tbody>
            {#each branchHazardControls as bhc}
              <tr>
                <td style={`padding-left: ${parseInt(bhc.branch.branch_level) * 10}px`}>
                  {#if bhc.expired}
                    <span class="text-danger"><i class="fa fa-exclamation-circle" title="{sgettext('$$DISABLED$$')}"></i></span>
                  {/if}

                  <span class:text-secondary={bhc.expired}>{bhc.branch.full_name}</span>

                </td>
                <td>
                  {#if bhc.global_control.expired}
                    <span class="text-danger"><i class="fa fa-exclamation-circle" title="{sgettext('$$EXPIRED$$')}"></i></span>
                  {/if}
                  <img src="{bhc.global_control.icon.url}" width="20px" alt="" />
                  <span class:text-secondary={bhc.global_control.expired || bhc.expired}>{bhc.global_control.name}</span>
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    {/if}
  </div>

  <div slot="footer">
    <button
      type="button"
      class="btn btn-secondary"
      on:click={() => jQuery(`#${modalId}`).modal('hide')}
      data-dismiss="modal">{sgettext('$$CLOSE$$')}</button>
  </div>
</Modal>